export default {
  container: 'px-[20px] mt-[24px]',
  title: 'font-interSemibold text-[24px] text-[#101828] mb-[34px]',
  contentWrapper: 'flex flex-col md:flex-row gap-[30px] sm:h-[calc(100vh-178px)] h-fit',
  tabsWrapper: 'flex md:flex-col gap-[20px] border-r border-[#E7E8EA]',
};
